<template>
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <div
      class="d-flex flex-column justify-center align-center"
      :style="{
        'text-align': 'center',
        width: '70%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <p>
        Terimakasih ! <br />
        Data Merchant telah berhasil di submit.
      </p>

      <p>No Pengajuan: {{ referenceNumber }}</p>

      <v-row align="center">
        <v-btn
          small
          color="warning"
          dark
          @click="goHome"
          :style="{ margin: '2px' }"
        >
          Home
        </v-btn>
        <v-btn
          small
          color="primary"
          dark
          @click="goTracking"
          :style="{ margin: '2px' }"
        >
          tracking pengajuan
        </v-btn>
      </v-row>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'step7',
  computed: {
    referenceNumber() {
      return this.$store.state.register.referenceNumber;
    },
    registeredId() {
      return this.$store.state.register.registeredId;
    },
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goTracking() {
      const trackingPath =
        this.$store.state.user.roleType == 'inputer'
          ? 'inputer-tracking-pengajuan'
          : 'tracking-pengajuan';

      this.$router.push(`/${trackingPath}/list/view/${this.registeredId}`);
    },
  },
};
</script>
